export const GET_DATA_EMPLOYEES_PROJECT_PROCESSED = 'GET_DATA_EMPLOYEES_PROJECT_PROCESSED';
export const SEND_DATA_EMPLOYEES_PROJECT_PROCESSED = 'SEND_DATA_EMPLOYEES_PROJECT_PROCESSED';
export const DATA_EMPLOYEES_PROJECT_PROCESSED_IN_SEARCH = 'DATA_PROJECT_ADVANCE_IN_SEARCH';
